import React, { useEffect, useRef, useState } from "react";
import classes from "./FactsNFigures.module.css";

//components
import Odometer from "../UI/Odometer/Odometer";
import Space from "../UI/Space/Space";
import AnimatedCard from "../UI/AnimatedCard/AnimatedCard";
import Figure from "../UI/Figure/Figure";
import Modal from "../UI/Modal/Modal";

//Libraries and Redux
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useDispatch } from "react-redux";
import { ScrollActions } from "../../store/Slices/ScrollSlice";


//icons
import Stethoscope from "../../images/stethoscope.png";
import Physiotherapy from "../../images/physiotherapy.png";
import ABC from "../../images/ABC.png";
import Evaluation from "../../images/evaluation.png";
import Gears from "../../images/gears.png";
import Hearing from "../../images/hearing.png";
import Lab from "../../images/labBottle.png";
import psychoTherapy from "../../images/psychotherapy.png";
import speechTherapy from "../../images/speechTherapy.png";
import Xray from "../../images/xray.png";
import Prosthetic from "../../images/prosthetic.png";
import MedicalCare from "../../images/medicalcare.png";
import Button from "../UI/Button/Button";
import CareersForm from "./Forms/Careers/CareersForm";
import StayTuned from "./Forms/StayTuned/StayTuned";
import ContactUs from "./Forms/ContactUs/ContactUs";
import PartnershipPrograms from "./PartnershipPrograms";

//This component shows the Facts and figures about LWAH and is placed under the Map section
//it also includes Buttons for Contact Us, Careers, Stay Tuned and their Modals 
const FactsNFigures = () => {
  const dispatch = useDispatch();
  const container = useRef(null);
  const contactUs = useRef(null);
  const careers = useRef(null);
  const stayTuned = useRef(null);

  gsap.registerPlugin(ScrollTrigger);
  //This useEffect tracks the scroll position of the component for SrollProgress Component
  useEffect(() => {
    let trigger = ScrollTrigger.create({
      trigger: container.current,
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
      // markers: true,
      onUpdate: (self) => {
        dispatch(ScrollActions.UpdateFacts(self.progress));
      },
    });

    return () => {
      trigger.kill();
    };
  }, []);

  //states responsible for the Opening of the Modals
  const [isCareersOpen, setIsCareersOpen] = useState(false);
  const [isStayTunedOpen, setIsStayTunedOpen] = useState(false);
  const [isContactUsOpen, setIsContactUsOpen] = useState(false);

  //Open Careers Modal
  const openCareers = (event) => {
    setIsCareersOpen(true);
  };
  //Open Stay Tuned Modal
  const openStayTuned = (event) => {
    setIsStayTunedOpen(true);
  };
  //Open Contact Us Modal
  const openContactUs = (event) => {
    setIsContactUsOpen(true);
  };
  //closed opened Modal
  const cancel = () => {
    setIsCareersOpen(false);
    setIsStayTunedOpen(false);
    setIsContactUsOpen(false)
  };

  return (
    <div className={classes.container} ref={container}>
      {isCareersOpen && (
        <Modal cancel={cancel} title={"Careers"} circle={2000}>
          <CareersForm />
        </Modal>
      )}
      {isStayTunedOpen && (
        <Modal cancel={cancel} title={"Stay Tuned"} circle={2500}>
          <StayTuned />
        </Modal>
      )}
      {isContactUsOpen && (
        <Modal cancel={cancel} title={"Contact Us"} circle={2500}>
          <ContactUs/>
        </Modal>
      )}
      <Space height={"600px"} />
      <div className={classes.bigNumber}>
        <Odometer
          value={33393}
          height={200}
          className={classes.counter}
          commaClassName={classes.yellow}
          duration={2}
        />
      </div>
      <div className={classes.bigTitle}>BENEFICIARIES</div>
      <Space height={"100px"} />
      <AnimatedCard className={classes.item}>
        <h2>
          <span className={classes.yellow}>LWAH</span> provides a wide range of
          social and medical services in its different centers, including{" "}
          <span className={classes.yellow}>LWAH</span>'s rehabilitation center,
          Beirut and Baalbeck Centers. There was 13% increase in provided
          services between 2018 and 2017
        </h2>
      </AnimatedCard>
      <Space height={100} />
      <div className={classes.row}>
        <Figure
          icon={Stethoscope}
          leftNumber={8090}
          rightNumber={15248}
          title="Registered cases at LWAH Clinics for consultations, follow-up and vaccination"
        />
        <Figure
          icon={Physiotherapy}
          leftNumber={897}
          rightNumber={677}
          title="Physiotherapy Patients"
        />
      </div>
      <Space height={100} />
      <div className={classes.row}>
        <Figure
          icon={Evaluation}
          leftNumber={39}
          rightNumber={268}
          title="Underwent Evaluation Tests including TOVA, IQ and CAT"
        />
        <Figure
          icon={Lab}
          leftNumber={887}
          rightNumber={3626}
          title="Laboratory Visits"
        />
      </div>
      <Space height={100} />
      <div className={classes.row}>
        <Figure
          icon={speechTherapy}
          leftNumber={327}
          rightNumber={440}
          title="Speech Therapy Patients"
        />
        <Figure
          icon={Gears}
          leftNumber={345}
          rightNumber={331}
          title="Psychomotor Therapy Patients"
        />
      </div>
      <Space height={100} />
      <div className={classes.row}>
        <Figure
          icon={Xray}
          leftNumber={479}
          rightNumber={2232}
          title="Imaging Services including X-Ray, Ultrasound and Mammography"
        />
        <Figure
          icon={Hearing}
          leftNumber={262}
          rightNumber={308}
          title="Hearing Aids"
        />
      </div>
      <Space height={100} />
      <div className={classes.row}>
        <Figure
          icon={ABC}
          leftNumber={463}
          rightNumber={254}
          title="Occupational Therapy Patients"
        />
        <Figure
          icon={psychoTherapy}
          leftNumber={228}
          rightNumber={334}
          title="Psychotherapy Patients"
        />
      </div>
      <Space height={100} />
      <div className={classes.row}>
        <Figure
          icon={Prosthetic}
          leftNumber={365}
          rightNumber={110}
          title="Received Prosthetic and Orthotic Devices"
        />
        <Figure
          icon={MedicalCare}
          leftNumber={13654}
          rightNumber={230}
          title="Beneficiary of Cases Of Technical And Medical AIDS"
        />
      </div>
      <Space height={200} />
      <PartnershipPrograms />
      <Space height={200} />
      <div className={classes.cards}>
        <Button className={classes.card} onClick={openContactUs}>
          <h3>CONTACT US</h3>
        </Button>
        <Button className={classes.card} onClick={openCareers}>
          <h3>CAREERS</h3>
        </Button>
        <Button className={classes.card} onClick={openStayTuned}>
          <h3>STAY TUNED</h3>
        </Button>
      </div>
      <Space height={100} />
    </div>
  );
};
export default FactsNFigures;
